import React, { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'

import { Spinner } from '@acorns/web-components'
import styled from 'styled-components'

import { TestIDs } from 'test/utils/testIds'
import theme from 'theme'

export interface DocumentHandle {
  scrollToBottom: () => void
}

interface Props {
  handleFinishLoading: () => void
  documentUrl: string
  bottomScrollOffset: number
}

const emptySpaces = ['&nbsp;', '<br>', '<br><br>']

const DocumentContainer = styled.div`
  font-size: 14px;
  line-height: 22px;
  word-wrap: break-word;

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    width: 100%;
    overflow: hidden;
  }
`

export const Document = (props: Props) => {
  const [documentContent, setDocumentContent] = useState<HTMLParagraphElement[]>()

  useEffect(() => {
    if (props.documentUrl) {
      fetch(props.documentUrl)
        .then(res => res.text())
        .then(result => {
          const parser = new DOMParser()
          const pElements = Array.from(
            parser.parseFromString(result, 'text/html').querySelectorAll('p'),
          )
          // Remove title "The Referral Disclosure" from document
          setDocumentContent([...pElements.slice(2)])
          props.handleFinishLoading()
        })
    }
  }, [props.documentUrl])

  if (!documentContent) {
    return <Spinner />
  }

  return (
    <DocumentContainer data-testid={TestIDs.REFERRAL_DISCLOSURE.DOCUMENT_TEXT}>
      {documentContent.map((el, index) => {
        const elementHtml = el.innerHTML
        return !emptySpaces.includes(elementHtml) ? (
          <p key={`pElement-${index}`}>{ReactHtmlParser(elementHtml)}</p>
        ) : null
      })}
    </DocumentContainer>
  )
}
